import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './ChangePassword.css';

const ChangePassword = () => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [showCurrentPassword, setShowCurrentPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const navigate = useNavigate();
    const { logout } = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();

        const passwordPolicy = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

        if (newPassword !== confirmPassword) {
            setError('New password and confirmation do not match');
            return;
        }

        if (!passwordPolicy.test(newPassword)) {
            setError('Password must be at least 8 characters and include uppercase, lowercase, number, and special character');
            return;
        }

        try {
            const token = localStorage.getItem('token');
            const userId = localStorage.getItem('id');

            const response = await fetch(`https://markazsync.com/api/users/${userId}/change-password`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({
                    current_password: currentPassword,
                    new_password: newPassword
                })
            });

            const data = await response.json();

            if (!response.ok) {
                setError(data.error || 'Failed to update password');
                setSuccess('');
            } else {
                logout();
                setSuccess('Password updated. Redirecting to login...');
                setError('');

                setTimeout(() => {
                    navigate('/', { replace: true });
                }, 1000);
            }
        } catch (error) {
            setError('An error occurred while changing the password');
            console.error(error);
        }
    };

    return (
        <div className="login-container change-password">
            <form className="login-form change-password-form" onSubmit={handleSubmit}>
                <h2>Change Password</h2>
                <p className="password-hint">
                    Password must be at least 8 characters and include uppercase, lowercase, number, and special character.
                </p>
                <p className="password-example">Example: Example@2024</p>
                {error && <p className="error-message">{error}</p>}
                {success && <p className="success-message">{success}</p>}
                <div className="password-field">
                    <input
                        type={showCurrentPassword ? "text" : "password"}
                        placeholder="Current Password"
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                        required
                    />
                    <button
                        type="button"
                        className="toggle-password"
                        onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                        aria-label={showCurrentPassword ? "Hide current password" : "Show current password"}
                    >
                        <i className={`bi ${showCurrentPassword ? "bi-eye-slash" : "bi-eye"}`} />
                    </button>
                </div>
                <div className="password-field">
                    <input
                        type={showNewPassword ? "text" : "password"}
                        placeholder="New Password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                    />
                    <button
                        type="button"
                        className="toggle-password"
                        onClick={() => setShowNewPassword(!showNewPassword)}
                        aria-label={showNewPassword ? "Hide new password" : "Show new password"}
                    >
                        <i className={`bi ${showNewPassword ? "bi-eye-slash" : "bi-eye"}`} />
                    </button>
                </div>
                <div className="password-field">
                    <input
                        type={showConfirmPassword ? "text" : "password"}
                        placeholder="Confirm New Password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                    />
                    <button
                        type="button"
                        className="toggle-password"
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        aria-label={showConfirmPassword ? "Hide confirm password" : "Show confirm password"}
                    >
                        <i className={`bi ${showConfirmPassword ? "bi-eye-slash" : "bi-eye"}`} />
                    </button>
                </div>
                <button type="submit">Update Password</button>
            </form>
        </div>
    );
};

export default ChangePassword;
